export default {
  index: "Introduction",
  "getting-started": "Getting Started",
  guides: "Guides",
  "verify-proofs": "Verify Proofs",
  faq: "FAQ",
  "other-resources": "Other Resources",
  website: {
    title: "pluto.xyz ↗",
    type: "page",
    href: "https://pluto.xyz",
    newWindow: true,
  },
};
